if (!customElements.get("spend-x-get-gift")) {
  class SpendXGetGift extends HTMLElement {
    constructor() {
      super();
      this.getElements();
      this.setupEventListeners();
    }
    getElements() {
      this.elements = {
        button: this.querySelectorAll("[data-button]")
      };
    }
    setupEventListeners() {
      this.elements.button.forEach((element) => {
        element.addEventListener("click", this.onButtonClick.bind(this));
      });
    }
    onButtonClick({ currentTarget }) {
      var _a;
      const parentElement = currentTarget.closest("[data-parent]");
      const selectElement = parentElement.querySelector("[data-select]");
      console.log("parentElement", parentElement, selectElement);
      if (!parentElement || !selectElement)
        return;
      currentTarget.setAttribute("disabled", true);
      let formData = {
        items: [
          {
            id: selectElement == null ? void 0 : selectElement.value,
            quantity: 1
          }
        ]
      };
      const cartDrawer = document.querySelector("cart-drawer");
      (_a = cartDrawer == null ? void 0 : cartDrawer.enableLoading) == null ? void 0 : _a.call(cartDrawer, this);
      fetch(`${routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then((response) => response.json()).then(() => {
        const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
        if (cartItems) {
          if (window.cartInstance) {
            window.cartInstance._updateCart(() => {
              var _a2;
              (_a2 = cartDrawer == null ? void 0 : cartDrawer.disableLoading) == null ? void 0 : _a2.call(cartDrawer, this);
            });
          }
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        currentTarget.removeAttribute("disabled");
      });
    }
  }
  customElements.define("spend-x-get-gift", SpendXGetGift);
}
